/*eslint-disable */
import { Field as Fieldmik, withFormik } from "formik";
import { Checkbox } from 'formik-semantic-ui';
import React,{useEffect, useState} from "react";
import { translate } from 'react-i18next';
import { connect } from "react-redux";
import { Button, Form as FormUi, Modal, Divider, Header, Dropdown , Radio, Icon} from 'semantic-ui-react';
import * as yup from "yup";
import CreatAxios from '../../../components/axiosComponent/create';
import UpdateAxios from '../../../components/axiosComponent/update';
import SearchDropdown from "../../../components/createShipmentComponent/searchDropdown";
import { MyNormalInput} from '../../../components/dynamicComponent/myInputs';
import { isBillingPartyBranchRequired } from "../../../features/features";
import { DateData } from "../../../components/dynamicComponent/datepick";
import {
  errorAlertDispatcher,
  infoAlertDispatcher, successAlertDispatcher,
  warningAlertDispatcher
} from "../../../redux/actions/alertAction";
import { AllRegex } from "../../../utils/validation";
import {
  INVALID_FIELDS, REQUIRED_FIELDS
} from "../../../utils/validationConstant";
import { LOCAL_STORAGE } from "../../../utils/constant";
import ReadAxios from "../../../components/axiosComponent/read";
import MyState from '../../../components/apiInputs/myState'
import AddCity from '../../../components/dynamicComponent/addCity'
import {MASTERS_MSG} from '../../../utils/toastMsgConstant'
import UploadFile from '../../../components/dynamicComponent/Upload'

const BillingPartyBranch = ({ isSubmitting, handleSubmit, values,
  vendorId, setFieldValue, touched, errors, t,
  branchModal, CloseModal, editUserMode, ...props }) => {

    const [exemptedReasons, setExemptedReasons] = useState([])
    useEffect(()=>{
      getExemptedReasons()
    },[])

    const getExemptedReasons = ()=>{
      ReadAxios({ url: `gstExemptedReason` }).then((dataArray) => {
        console.log(dataArray);
        let result = dataArray.data.resultSet.map((item, index) => {
          return {
            raw: { ...item },
            text: item.GSTExemptedReasonName,
            key: item.GSTExemptedReasonId,
            value: item.GSTExemptedReasonId,
          };
        });
        setExemptedReasons(result)
      }).catch((err)=>{
        console.log(err);
      })
    }

    const getItReturnUrlImage = (imageKey) => {
      const userId = LOCAL_STORAGE.userId;
      const token = LOCAL_STORAGE.userToken;
      const customerNo = LOCAL_STORAGE.customerNo;
      return `${process.env.REACT_APP_MASTER_API}/getBillingPartyDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
    }
  
    const getFile = (imageKey) => {
      const userId = LOCAL_STORAGE.userId;
      const token = LOCAL_STORAGE.userToken;
      const customerNo = LOCAL_STORAGE.customerNo;
      const url = `${process.env.REACT_APP_MASTER_API}/getBillingPartyDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
      window.open(url, '_blank').focus();
    }

    const isImageFile = (key) => {
      let image_ext = ["jpeg", "jpg", "png"]
      let key_arr = key && key.split(".")
      let key_ext = key_arr && key_arr.length && key_arr[key_arr.length - 1]
      if(image_ext.includes(key_ext)) return true;
      else return false;
    }

  return (
    <Modal
      onClose={CloseModal}
      open={branchModal}
      size="large"
      className="p-overflow-initial"
    >
      <Modal.Header style={{ fontSize: "14px" }}>{props.editData ? t('edit_title') : t('add')} {t("title")}</Modal.Header>
      <Modal.Content scrolling>
        <div className="ui form small">
          <FormUi.Group inline={errors.billingPartyBranchName ? false : true}>
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.branch")} <span className="red">*</span></label>
            </FormUi.Field>
            <FormUi.Field error={values.billingPartyBranchName ? false : true} width="4">
              <Fieldmik name="billingPartyBranchName" component={MyNormalInput} placeholder={t("table_placeholder.branch")} />
              {touched.billingPartyBranchName && errors.billingPartyBranchName ? <small className="text-danger">{errors.billingPartyBranchName}</small> : ''}
            </FormUi.Field>
            <FormUi.Field width="2" />
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.state")}</label>
            </FormUi.Field>
            <FormUi.Field width="4">
              <Fieldmik name="billingPartyBranchStateId" component={MyState} placeholder={props?.editData?.state || t("table_placeholder.state")}/>
            </FormUi.Field>
          </FormUi.Group>
          
          <FormUi.Group inline={errors.billingPartyBranchCityId ? false : true}>
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.city")} {""}</label>
            </FormUi.Field>
            <FormUi.Field error={values.billingPartyBranchCityId ? false : true} width="4">
            <Fieldmik
                    type="text"
                    component={AddCity}
                    name="billingPartyBranchCityId"
                    placeholder={values.cityName || t("table_placeholder.city")}
                  />
              {touched.cityName && errors.cityName ? <small className="text-danger">{errors.cityName}</small> : ''}
            </FormUi.Field>
            <FormUi.Field width="2" />
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.pincode")}</label>
            </FormUi.Field>
            <FormUi.Field error={values.billingPartyBranchPincode ? false : true} width="4">
              <Fieldmik name="billingPartyBranchPincode" component={MyNormalInput} placeholder={t("table_placeholder.pincode")}/>
              {touched.billingPartyBranchPincode && errors.billingPartyBranchPincode ? <small className="text-danger">{errors.billingPartyBranchPincode}</small> : ''}
            </FormUi.Field>
          </FormUi.Group>
         
          <FormUi.Group inline={errors.billingPartyBranchAddress ? false : true}>
             <FormUi.Field width="2">
              <label className="labelName">{t("table_header.pan_number")}{" "} </label>
            </FormUi.Field>
            <FormUi.Field error={values.contactPersonName ? false : true} width="4">
              <Fieldmik name="billingPartyBranchPan" type="text" component={MyNormalInput} placeholder={t("table_placeholder.pan_number")} />
              {touched.billingPartyBranchPan && errors.billingPartyBranchPan ? <small className="text-danger">{errors.billingPartyBranchPan}</small> : ''}
            </FormUi.Field>
            <FormUi.Field width="2" />

            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.contactPersonName")}{" "} </label>
            </FormUi.Field>
            <FormUi.Field error={values.contactPersonName ? false : true} width="4">
              <Fieldmik name="contactPersonName" type="text" component={MyNormalInput} placeholder={t("table_placeholder.contactPersonName")} />
              {touched.contactPersonName && errors.contactPersonName ? <small className="text-danger">{errors.contactPersonName}</small> : ''}
            </FormUi.Field>
          </FormUi.Group>

          <FormUi.Group inline={errors.mobileNo ? false : true}>
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.mobile")}{" "} </label>
            </FormUi.Field>
            <FormUi.Field error={values.mobileNo ? false : true} width="4">
              <Fieldmik name="mobileNo" type="text" component={MyNormalInput} placeholder={t("table_placeholder.mobile")} />
              {touched.mobileNo && errors.mobileNo ? <small className="text-danger">{errors.mobileNo}</small> : ''}
            </FormUi.Field>
            <FormUi.Field width="2" />

            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.landLineNo")}</label>
            </FormUi.Field>
            <FormUi.Field error={values.landLineNo ? false : true} width="4">
              <Fieldmik name="landLineNo" type="text" component={MyNormalInput} placeholder={t("table_placeholder.landLineNo")} />
              {touched.landLineNo && errors.landLineNo ? <small className="text-danger">{errors.landLineNo}</small> : ''}
            </FormUi.Field>
            <FormUi.Field width={2} />
          </FormUi.Group>
          <FormUi.Group inline={errors.billingPartyBranchAddress ? false : true}>
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.address")}{" "} </label>
            </FormUi.Field>
            <FormUi.Field error={values.billingPartyBranchAddress ? false : true} width="4">
              <Fieldmik name="billingPartyBranchAddress" type="text" component="textarea" rows="4" placeholder={t("table_placeholder.address")}/>
              {touched.billingPartyBranchAddress && errors.billingPartyBranchAddress ? <small className="text-danger">{errors.billingPartyBranchAddress}</small> : ''}
            </FormUi.Field>
            </FormUi.Group>
          
          <Divider horizontal>
                <Header as='h4'>
                {t("divider_header.gst_details")||"GST Details" }
                </Header>
              </Divider>

          <FormUi.Group>
            <FormUi.Field width="2">
              <label className="labelName mt-2">{t("table_header.is_gst_applicable")||"Is GST Applicable?"}</label>
            </FormUi.Field>
            <FormUi.Field width="2">
                    <Radio label="No" className='mt-2' name='isGstApplicable' value='No'
                      checked={values.isGstApplicable === false} onChange={() => { 
                        setFieldValue("isGstApplicable", !values.isGstApplicable)
                        setFieldValue("billingPartyBranchGst",'')
                        setFieldValue("isGSTExempted",false)
                        setFieldValue("gstExemptedReasonId",'')
                         }} />
                  </FormUi.Field>
                  <FormUi.Field width="2">
                    <Radio label="Yes" className='mt-2' name='isGstApplicable' value='Yes'
                      checked={values.isGstApplicable === true} onChange={() => { setFieldValue("isGstApplicable", !values.isGstApplicable) }} />
                  </FormUi.Field>
            <FormUi.Field width="2" />

            {
              values.isGstApplicable &&
              <>
              <FormUi.Field width="2">
              <label className="labelName mt-2">{t("table_header.gst_no")||"GST Number"} <span className="red">*</span></label>
            </FormUi.Field>
            <FormUi.Field width="4">
            <Fieldmik name="billingPartyBranchGst" type="text" component={MyNormalInput} placeholder={t("table_placeholder.gst_no")} />
            {touched.billingPartyBranchGst && errors.billingPartyBranchGst ? <small className="text-danger">{errors.billingPartyBranchGst}</small> : ''}
            </FormUi.Field>
            </>
            }
          </FormUi.Group>

        {values.isGstApplicable&&
         <>
        <FormUi.Group>
           
                  <FormUi.Field width="2">
                  <label className="labelName mt-2">{t("table_header.is_gst_exmepted")||"Is GST Exempted?"}</label>
                  </FormUi.Field>
          
                  <FormUi.Field width="2">
                    <Radio label="No" className='mt-2' name='isGSTExempted' value='No'
                      checked={values.isGSTExempted === false} onChange={() => { 
                        setFieldValue("isGSTExempted", !values.isGSTExempted)
                        setFieldValue("gstExemptedReasonId",'')
                         }} />
                  </FormUi.Field>
                  <FormUi.Field width="2">
                    <Radio label="Yes" className='mt-2' name='isGSTExempted' value='Yes'
                      checked={values.isGSTExempted === true} onChange={() => { setFieldValue("isGSTExempted", !values.isGSTExempted) }} />
                  </FormUi.Field>
            <FormUi.Field width="2" />
            {
              values.isGSTExempted &&
              <>
               <FormUi.Field width="2">
              <label className="labelName mt-2">{t("table_header.gst_exempted_reason")||"GST Exempted Reason"}</label>
            </FormUi.Field>
       <FormUi.Field className="labelName mt-2" width="4">
          <Dropdown
            selection
            name="gstExemptedReasonId"
            style={{ width: '100%' }}
            options={exemptedReasons}
            onChange={(name, data) => {
              setFieldValue("gstExemptedReasonId", data.value);
            }}
            value={values.gstExemptedReasonId}
            placeholder={t("table_placeholder.gst_exempted_reason")}
            {...props}
        />
        </FormUi.Field>
              </> 
            }
        </FormUi.Group>

            <FormUi.Group>
              <FormUi.Field width={2}>
                <label>{t("gst_certificate" || "GST Document")}</label>
              </FormUi.Field>
              <FormUi.Field width={4}>
                <div className="row ml-1">
                <Fieldmik
                  name="billingPartyBranchGstPath"
                  style={{ width: "23%" }}
                  buttonName={
                    values.billingPartyBranchGstPath
                      ? "File Selected"
                      : "Choose File"
                  }
                  className="w3-button w3-round w3-small w3-border w3-hover-blue"
                  typer={["pdf", "jpeg", "jpg", "png"]}
                  values={values}
                  component={UploadFile}
                  upload_url={`masters/addBillingPartyDocument`}
                />
                {
                  values?.billingPartyBranchGstPath && isImageFile(values?.billingPartyBranchGstPath) ?
                    <a href={getItReturnUrlImage(values?.billingPartyBranchGstPath)} target="_blank" className="ml-1">
                      <img src={getItReturnUrlImage(values?.billingPartyBranchGstPath)} style={{ height: 60, width: 60 }} />
                    </a> :
                    <Button
                      onClick={() => getFile(values?.billingPartyBranchGstPath)}
                      basic
                      size="mini"
                      type="button"
                      icon
                      className="ml-1"
                    >
                      <Icon name="eye" color="blue" />
                    </Button>
                }
                </div>
              </FormUi.Field>
            </FormUi.Group>
        </>
        }

        <Divider horizontal>
                <Header as='h4'>
                {t("divider_header.bank_details")||"Bank Details" }
                </Header>
              </Divider>

              <FormUi.Group inline={errors.billingPartyBranchBankName ? false : true}>
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.bank_name")}</label>
            </FormUi.Field>
            <FormUi.Field error={values.billingPartyBranchBankName ? false : true} width="4">
              <Fieldmik name="billingPartyBranchBankName" type="text" component={MyNormalInput} placeholder={t("table_placeholder.bank_name")} />
              {touched.billingPartyBranchBankName && errors.billingPartyBranchBankName ? <small className="text-danger">{errors.billingPartyBranchBankName}</small> : ''}
            </FormUi.Field>
            <FormUi.Field width="2" />
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.acc_holder")}</label>
            </FormUi.Field>
            <FormUi.Field error={values.billingPartyBranchBankAccountHolder ? false : true} width="4">
              <Fieldmik name="billingPartyBranchBankAccountHolder" type="text" component={MyNormalInput} placeholder={t("table_placeholder.acc_holder")} />
              {touched.billingPartyBranchBankAccountHolder && errors.billingPartyBranchBankAccountHolder ? <small className="text-danger">{errors.billingPartyBranchBankAccountHolder}</small> : ''}
            </FormUi.Field>
          </FormUi.Group>
          <FormUi.Group inline={errors.billingPartyBranchAccountNumber ? false : true}>
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.acc_number")}</label>
            </FormUi.Field>
            <FormUi.Field error={values.billingPartyBranchAccountNumber ? false : true} width="4">
              <Fieldmik name="billingPartyBranchAccountNumber" type="text" component={MyNormalInput} placeholder={t("table_placeholder.acc_number")} />
              {touched.billingPartyBranchAccountNumber && errors.billingPartyBranchAccountNumber ? <small className="text-danger">{errors.billingPartyBranchAccountNumber}</small> : ''}
            </FormUi.Field>
            <FormUi.Field width="2" />
            <FormUi.Field width="2">
              <label className="labelName">{t("table_header.ifsc_code")}</label>
            </FormUi.Field>
            <FormUi.Field error={values.billingPartyBranchBankIFSC ? false : true} width="4">
              <Fieldmik name="billingPartyBranchBankIFSC" type="text" component={MyNormalInput} placeholder={t("table_placeholder.ifsc_code")} />
              {touched.billingPartyBranchBankIFSC && errors.billingPartyBranchBankIFSC ? <small className="text-danger">{errors.billingPartyBranchBankIFSC}</small> : ''}
            </FormUi.Field>
          </FormUi.Group>

          <FormUi.Group>
                  <FormUi.Field width={2}>
                    <label>{t("cancelled_cheque"||"Cancelled Cheque")}</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                  <div className="row ml-1">
                    <Fieldmik
                      name="billingPartyBranchCancelledChequePath"
                      style={{ width: "23%" }}
                      buttonName={
                        values.billingPartyBranchCancelledChequePath
                          ? "File Selected"
                          : "Choose File"
                      }
                      className="w3-button w3-round w3-small w3-border w3-hover-blue"
                      typer={["pdf", "jpeg", "jpg", "png"]}
                      values={values}
                      component={UploadFile}
                      upload_url={`masters/addBillingPartyDocument`}
                    />
              {
                values?.billingPartyBranchCancelledChequePath && isImageFile(values?.billingPartyBranchCancelledChequePath) ?
                  <a href={getItReturnUrlImage(values?.billingPartyBranchCancelledChequePath)} target="_blank" className="ml-1">
                    <img src={getItReturnUrlImage(values?.billingPartyBranchCancelledChequePath)} style={{ height: 60, width: 60 }} />
                  </a> :
                  <Button
                    onClick={() => getFile(values?.billingPartyBranchCancelledChequePath)}
                    basic
                    size="mini"
                    type="button"
                    icon
                    className="ml-1"
                  >
                    <Icon name="eye" color="blue" />
                  </Button>
              }
              </div>
                  </FormUi.Field>
       </FormUi.Group>

        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button color='green' size="mini" type='button' onClick={CloseModal}>
          {t("cancel")}
        </Button>
        <Button type='submit' disabled={isSubmitting} onClick={handleSubmit} size="mini" color="blue">
          {t("ok")}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
const FormikUserEdit = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
      billingPartyBranchName: props?.editData?.billingPartyBranchName || '',
      isGstApplicable: props?.editData?.isGstApplicable ? true : false,
      billingPartyBranchCode: props?.editData?.billingPartyBranchCode || null,
      cityName: props?.editData?.cityName || '',
      billingPartyBranchCityId: props?.editData?.billingPartyBranchCityId || '',
      billingPartyBranchPincode: props?.editData?.billingPartyBranchPincode || '',
      billingPartyBranchStateId: props?.editData?.billingPartyBranchStateId || 0,
      state: props?.editData?.state || '',
      billingPartyBranchGst: props?.editData?.billingPartyBranchGst?.trim() || '',
      billingPartyBranchAddress: props?.editData?.billingPartyBranchAddress || '',
      billingPartyBranchBankName: props?.editData?.billingPartyBranchBankName || '',
      billingPartyBranchBankAccountHolder: props?.editData?.billingPartyBranchBankAccountHolder || '',
      billingPartyBranchAccountNumber: props?.editData?.billingPartyBranchAccountNumber || '',
      billingPartyBranchBankIFSC: props?.editData?.billingPartyBranchBankIFSC || '',
      billingPartyId: props?.editDataPass?.billingPartyId || '',
      createdByName: props?.editData?.createdByName || null,
      updatedByName: props?.editData?.updatedByName || null,
      createdOn: props?.editData?.updatedByName || null,
      updatedOn: props?.editData?.updatedOn || null,
      contactPersonName: props?.editData?.contactPersonName || '',
      mobileNo: props?.editData?.mobileNo || '',
      landLineNo: props?.editData?.landLineNo || '',
      isGSTExempted:props?.editData?.isGSTExempted ? true : false,
      gstExemptedReasonId:props?.editData?.GSTExemptedReasonId || '',
      billingPartyBranchPan: props?.editData?.billingPartyBranchPan || '',
      billingPartyBranchGstPath: props?.editData?.billingPartyBranchGstPath || '',
      billingPartyBranchCancelledChequePath: props?.editData?.billingPartyBranchCancelledChequePath || '',
    }
  },
  validationSchema: yup.object({
    billingPartyBranchName: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).max(50,INVALID_FIELDS.INVALID_MAXIMUMSIZE(50)),
    cityName: yup.string().optional().nullable(),
    billingPartyBranchPincode: yup.string().optional().nullable().matches(AllRegex.Pincode, INVALID_FIELDS.INVALID_PINCODE),
    billingPartyBranchStateId: yup.number().optional().nullable(),
    billingPartyBranchBankName: yup.string().optional().matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME).nullable().max(50,INVALID_FIELDS.INVALID_MAXIMUMSIZE(50)),
    billingPartyBranchAccountNumber: yup.string().optional().matches(AllRegex.BankAccNumber, INVALID_FIELDS.INVALID_BANK_ACCOUNT_NO).nullable().max(50,INVALID_FIELDS.INVALID_MAXIMUMSIZE(50)),
    billingPartyBranchBankIFSC: yup.string().optional().matches(AllRegex.BankIFSCcode, INVALID_FIELDS.INVALID_IFSC_CODE).nullable().max(30,INVALID_FIELDS.INVALID_MAXIMUMSIZE(30)),
    billingPartyBranchBankAccountHolder: yup.string().optional().matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME).nullable().max(50,INVALID_FIELDS.INVALID_MAXIMUMSIZE(50)),
    mobileNo: yup.string().optional().matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO).nullable(),
    landLineNo: yup.string().optional().matches(AllRegex.LandlineNumber, INVALID_FIELDS.INVALID_LAND_LINE).nullable(),
    billingPartyBranchAddress: yup.string().optional().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS).nullable(),
    contactPersonName: yup.string().optional().matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME).nullable().max(50,INVALID_FIELDS.INVALID_MAXIMUMSIZE(50)),
    billingPartyBranchGst:yup.string().when("isGstApplicable",{is: true,then:yup.string().matches(AllRegex.GSTIN, INVALID_FIELDS.INVALID_GST_NUMBER).required(REQUIRED_FIELDS.GST_NO_REQUIRED)}),
    billingPartyBranchPan : yup.string().optional().matches(AllRegex.PANIN, INVALID_FIELDS.INVALID_PAN_NUMBER).nullable(),
  }),

  async handleSubmit(values, { props }) {
    if(!values.isGSTExempted) values.gstExemptedReasonId= '0'
    if(!values.isGstApplicable) {
      values.billingPartyBranchGst=' '
      values.isGSTExempted=false
      values.isGstApplicable='0'
      values.gstExemptedReasonId= '0'
    }else{
      values.isGstApplicable='1'
    }
    if (props?.editData?.billingPartyBranchId) {
      await UpdateAxios({
        url: `billing_party_branch/${props.editData.billingPartyBranchId}`,
        payload: { ...values },
      }).then((response) => {
        if(response.data.status===200){
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: MASTERS_MSG.BILLING_PARTY_BRANCH.UPDATE_SUCCESS,
          };
          props.CloseModal(true)
          window.location.reload()
          props.successAlertDispatcher(alert);
          props.onFormSubmit();
        }else{
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: `${res.data.message}`,
          };
          props.errorAlertDispatcher(alert);
        }
      })
        .catch((err) => {
            let alert = {
              type: "error",
              messageHeader: "Error",
              messageBody: `${err.data.message} `,
            };
            props.errorAlertDispatcher(alert);
        });
    } else {
      await CreatAxios({
        url: `billing_party_branch/`,
        payload: { ...values },
      })
        .then((res) => {
          if(res.data.status===200){
            let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: MASTERS_MSG.BILLING_PARTY_BRANCH.CREATE_SUCCESS,
          };
          props.successAlertDispatcher(alert).then(()=>{
            props.CloseModal(true)
            props.onFormSubmit();
          })
        }else{
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: `${res.data.message}`,
          };
          props.errorAlertDispatcher(alert);
        }
        })
        .catch((err) => {
            let alert = {
              type: "error",
              messageHeader: "Error",
              messageBody: `${err.data.message}`,
            };
            props.errorAlertDispatcher(alert);
        });
    }
  }
})(BillingPartyBranch)

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate('branch')(FormikUserEdit))
